/* Catalogue playback and non-obstructive mobile trustmarks. No checkout changes. */
(() => {
  'use strict';
  const initialiseCatalogue = (catalogue) => {
    if (catalogue.dataset.audioInitialised) return;
    catalogue.dataset.audioInitialised = 'true';
    catalogue.querySelectorAll('.j2-vocal-row').forEach((row) => {
      const audio = row.querySelector('audio');
      const button = row.querySelector('.j2-vr-play-btn');
      const status = row.querySelector('.ukrv-audio-status');
      if (!audio || !button) return;
      const sync = () => {
        const playing = !audio.paused && !audio.ended;
        button.setAttribute('aria-pressed', String(playing));
        button.setAttribute('aria-label', `${playing ? 'Pause' : 'Play'} ${button.dataset.title}`);
        row.classList.toggle('playing', playing);
      };
      const fail = () => {
        audio.pause();
        status.textContent = 'This preview could not play. Please try again.';
        status.hidden = false;
        sync();
      };
      button.addEventListener('click', async () => {
        if (button.dataset.loading) return;
        status.hidden = true;
        if (!audio.paused) { audio.pause(); return; }
        document.querySelectorAll('audio').forEach((other) => { if (other !== audio) other.pause(); });
        if (audio.ended) audio.currentTime = 0;
        button.dataset.loading = 'true';
        button.setAttribute('aria-busy', 'true');
        try { await audio.play(); }
        catch (error) { if (error.name !== 'AbortError') fail(); }
        finally { delete button.dataset.loading; button.removeAttribute('aria-busy'); sync(); }
      });
      ['play', 'pause', 'ended'].forEach((name) => audio.addEventListener(name, sync));
      audio.addEventListener('error', fail);
    });
    catalogue.classList.add('ukrv-audio-ready');
  };
  const initialise = (scope = document) => {
    if (scope.matches?.('[data-ukrv-catalogue]')) initialiseCatalogue(scope);
    scope.querySelectorAll('[data-ukrv-catalogue]').forEach(initialiseCatalogue);
  };
  initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('audio').forEach((audio) => audio.pause()));
  window.addEventListener('pagehide', () => document.querySelectorAll('[data-ukrv-catalogue] audio').forEach((audio) => audio.pause()));

  // Pause floating chat while purchase controls are on screen on a phone.
  const visiblePurchaseControls = new Set();
  const purchaseObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) visiblePurchaseControls.add(entry.target);
      else visiblePurchaseControls.delete(entry.target);
    });
    for (const control of visiblePurchaseControls) {
      if (!control.isConnected) visiblePurchaseControls.delete(control);
    }
    document.body.toggleAttribute('data-ukrv-purchase-visible', visiblePurchaseControls.size > 0);
  });
  const observePurchases = (scope = document) => scope.querySelectorAll('.j2-buy-btn, .j2vp__buy').forEach((control) => purchaseObserver.observe(control));
  observePurchases();
  document.addEventListener('shopify:section:load', (event) => observePurchases(event.target));

  // Close Dawn's mobile menu after choosing a catalogue anchor on the current page.
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('#menu-drawer a');
    if (!link) return;
    const drawer = link.closest('header-drawer');
    const details = drawer?.querySelector('details');
    if (drawer?.closeMenuDrawer && details) {
      drawer.closeMenuDrawer(event, details.querySelector('summary'));
    }
  });

  // Third-party app markup is injected after page load. Only compact floating
  // trustmark widgets are marked; static badges and full trust panels remain.
  let queued = false;
  const markFloatingTrustmarks = () => {
    queued = false;
    document.querySelectorAll('[id*="trustedsite" i], [class*="trustedsite" i], [id*="mcafee" i], iframe[src*="trustedsite" i], iframe[src*="mcafeesecure" i]').forEach((node) => {
      let candidate = node;
      for (let depth = 0; candidate && candidate !== document.body && depth < 4; depth++, candidate = candidate.parentElement) {
        if (candidate.hasAttribute('data-ukrv-floating-trustmark')) break;
        if (getComputedStyle(candidate).position !== 'fixed') continue;
        const bounds = candidate.getBoundingClientRect();
        if (bounds.width <= 260 && bounds.height <= 240) candidate.setAttribute('data-ukrv-floating-trustmark', '');
        break;
      }
    });
  };
  const queueTrustmarks = () => {
    if (!queued) { queued = true; requestAnimationFrame(markFloatingTrustmarks); }
  };
  const observer = new MutationObserver(queueTrustmarks);
  observer.observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['style']});
  window.addEventListener('resize', queueTrustmarks, {passive: true});
  queueTrustmarks();
})();
